module.exports = __webpack_public_path__ + "static/img/team_default.56eedc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team_default.png
// module id = 8Bml
// module chunks = 1